import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from '@/composables/use-i18n';
import { useSimilarParaScroll } from '@/composables/use-similar-para-scroll';
import { useSimilarParagraph } from '@/composables/use-similar-paragraph';
import { useCompareWording } from '@/composables/use-compare-wording';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareSimilarParaBar',
  setup(__props) {

const { t } = useI18n();
const {
    curSimilarParaNum,
    curSimilarParaNumSerialIdx,
    curSimilarParaListLeng,

    showSimilarParaBar,

    changeSimilarParaNumSerialIdx,
    getCurScrollInfo,
} = useSimilarParaScroll();

const { scrollToSimilarPara } = useSimilarParagraph();

const { showWordingNotFoundBar } = useCompareWording();

const prevDisabled = computed(() => {
    return curSimilarParaNumSerialIdx.value <= 1;
});

const nextDisabled = computed(() => {
    return curSimilarParaNumSerialIdx.value >= curSimilarParaListLeng.value;
});

const scrollToSimilar = (index) => {
    changeSimilarParaNumSerialIdx(index);
    const params = getCurScrollInfo('right');
    scrollToSimilarPara(params);
};


return { __sfc: true,t, curSimilarParaNum, curSimilarParaNumSerialIdx, curSimilarParaListLeng, showSimilarParaBar, changeSimilarParaNumSerialIdx, getCurScrollInfo, scrollToSimilarPara, showWordingNotFoundBar, prevDisabled, nextDisabled, scrollToSimilar }
}

})